import { colors, fonts, fontWeights } from 'ui/theme';
import { ShapeSize } from '../../types';
import { deleteIcon, noteIcon } from '../../icons';
import { shapeNames } from './ids';

export const DEFAULT_ACCENT_COLOR = colors.grey90;
export const DEFAULT_BACKGROUND_ACCENT_COLOR = colors.grey5;
export const DEFAULT_BORDER_ACCENT_COLOR = colors.grey35;
export const DEFAULT_FONT = fonts.sansSerif;
export const DEFAULT_FONT_SIZE = 14;
export const DEFAULT_LINE_HEIGHT = 20;
export const DEFAULT_FONT_STYLE = 'normal';
export const DEFAULT_FONT_WEIGHT = fontWeights.medium;
export const DEFAULT_NODE_WIDTH = 272;
export const DEFAULT_NODE_HEIGHT = 104;
export const DEFAULT_NODE_SIZE: ShapeSize = [DEFAULT_NODE_WIDTH, DEFAULT_NODE_HEIGHT];
export const DEFAULT_NOTE_WIDTH = 184;
export const DEFAULT_NOTE_HEIGHT = 184;
export const DEFAULT_NOTE_SIZE: ShapeSize = [DEFAULT_NOTE_WIDTH, DEFAULT_NOTE_HEIGHT];
export const HORIZONTAL_PADDING = 10;
export const NODE_BACKGROUND_COLOR = colors.white;
export const ICON_BACKGROUND_SIZE = 44;
export const ICON_SIZE = 24;
export const DELETE_DIAMETER = 24;
export const DELETE_ICON_SIZE = 16;
export const MIN_ANCHOR_DISTANCE = 130;
export const MIN_ANCHOR_DISTANCE_FROM_SIDE = MIN_ANCHOR_DISTANCE / 2;

/**
 * How the text is aligned within a node
 * NOTE: This works differently from html.  Instead of the text being aligned
 * within a block, the text is aligned relative to a point.  IE: Given a text
 * width of 50, the following will happen for each alignment:
 * - `start`: text will start at `x` and end at `x + 50`
 * - `end`: text will start at `x - 50` and end at `x`
 * - `center`: text will start at `x - 25` and end at `x + 25`
 */
export enum TextAlign {
  /** Text starts at `x` and ends at `x + TEXT_WIDTH` */
  Start = 'start',
  /** Text starts at `x - TEXT_WIDTH` and ends at `x` */
  End = 'end',
  /** Text starts at `x - TEXT_WIDTH / 2` and ends at `x + TEXT_WIDTH / 2` */
  Center = 'center',
}

export const fontConfig = {
  fs11: {
    fontSize: 11,
    lineHeight: 12,
  },
  fs12: {
    fontSize: 12,
    lineHeight: 14,
  },
  fs13: {
    fontSize: 13,
    lineHeight: 16,
  },
  fs14: {
    fontSize: DEFAULT_FONT_SIZE,
    lineHeight: DEFAULT_LINE_HEIGHT,
  },
  fs16: {
    fontSize: 16,
    lineHeight: 20,
  },
  default: {
    textAlign: 'left',
    textBaseline: 'middle',
    fontFamily: DEFAULT_FONT,
  },
};

export const deleteStyles = {
  [shapeNames.deleteCircle]: {
    width: DELETE_DIAMETER,
    height: DELETE_DIAMETER,
    r: DELETE_DIAMETER / 2,
    fill: colors.red100,
    hoverFill: colors.red50,
    cursor: 'pointer',
    opacity: 0,
  },
  [shapeNames.deleteIcon]: {
    img: deleteIcon,
    width: DELETE_ICON_SIZE,
    height: DELETE_ICON_SIZE,
    cursor: 'pointer',
    opacity: 0,
  },
};

export const deleteStylesActive = {
  [shapeNames.deleteCircle]: {
    opacity: 1,
  },
  [shapeNames.deleteIcon]: {
    opacity: 1,
  },
};

export const noteIndicatorStyles = {
  [shapeNames.noteIcon]: {
    img: noteIcon,
    x: -ICON_SIZE - 4,
  },
};
